import { render, staticRenderFns } from "./AppBarDesktop.vue?vue&type=template&id=5d35c497&"
import script from "./AppBarDesktop.vue?vue&type=script&lang=js&"
export * from "./AppBarDesktop.vue?vue&type=script&lang=js&"
import style0 from "./AppBarDesktop.vue?vue&type=style&index=0&id=5d35c497&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports